/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './payment_instrument';
import './tender';
import '../status';
import './bill';
import '../id_pair';
import './cart';
import '../gift_cards/data';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "client": {
        "nested": {
          "bills": {
            "nested": {
              "GetBillsRequest": {
                "fields": {
                  "query": {
                    "type": ".squareup.client.bills.GetBillsRequest.Query",
                    "id": 1,
                    "rule": "optional"
                  },
                  "limit": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  },
                  "paginationToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "queryParams": {
                    "type": ".squareup.client.bills.GetBillsRequest.QueryParams",
                    "id": 5,
                    "rule": "optional"
                  },
                  "employeeToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "QueryStringType": {
                    "values": {
                      "UNKNOWN_QUERY_STRING_TYPE": 0,
                      "USER_QUERY": 1,
                      "PAN": 2,
                      "ENCRYPTED_TRACK_2": 3,
                      "ENCRYPTED_TRACK_DATA": 4,
                      "TRACK_2": 5,
                      "ENCRYPTED_READER_DATA_DUKPT_SWIPE": 6,
                      "ENCRYPTED_READER_DATA_DUKPT_CHIP": 7
                    }
                  },
                  "Query": {
                    "fields": {
                      "queryStringType": {
                        "type": ".squareup.client.bills.GetBillsRequest.QueryStringType",
                        "id": 1,
                        "rule": "optional"
                      },
                      "queryString": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "InstrumentSearch": {
                    "fields": {
                      "paymentInstrument": {
                        "type": ".squareup.client.bills.PaymentInstrument",
                        "id": 1,
                        "rule": "optional"
                      },
                      "entryMethod": {
                        "type": ".squareup.client.bills.CardTender.Card.EntryMethod",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "QueryParams": {
                    "fields": {
                      "queryString": {
                        "type": "string",
                        "id": 1
                      },
                      "instrumentSearch": {
                        "type": ".squareup.client.bills.GetBillsRequest.InstrumentSearch",
                        "id": 2
                      }
                    },
                    "nested": {
                      "filter": {
                        "oneof": ["queryString", "instrumentSearch"]
                      }
                    }
                  }
                }
              },
              "GetBillsResponse": {
                "fields": {
                  "status": {
                    "type": ".squareup.client.Status",
                    "id": 1,
                    "rule": "optional"
                  },
                  "bill": {
                    "type": ".squareup.client.bills.Bill",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "paginationToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "GetBillByTenderServerIdRequest": {
                "fields": {
                  "tenderServerId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetBillByTenderServerIdResponse": {
                "fields": {
                  "status": {
                    "type": ".squareup.client.Status",
                    "id": 1,
                    "rule": "optional"
                  },
                  "bill": {
                    "type": ".squareup.client.bills.Bill",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetBillByBillServerTokenRequest": {
                "fields": {
                  "billServerToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetBillByBillServerTokenResponse": {
                "fields": {
                  "status": {
                    "type": ".squareup.client.Status",
                    "id": 1,
                    "rule": "optional"
                  },
                  "bill": {
                    "type": ".squareup.client.bills.Bill",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetBillFamiliesRequest": {
                "fields": {
                  "query": {
                    "type": ".squareup.client.bills.GetBillFamiliesRequest.Query",
                    "id": 1,
                    "rule": "optional"
                  },
                  "limit": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  },
                  "paginationToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "excludeRelatedBills": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "populateTenderContactData": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "employeeToken": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "InstrumentSearch": {
                    "fields": {
                      "paymentInstrument": {
                        "type": ".squareup.client.bills.PaymentInstrument",
                        "id": 1,
                        "rule": "optional"
                      },
                      "entryMethod": {
                        "type": ".squareup.client.bills.CardTender.Card.EntryMethod",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "PaymentSearch": {
                    "fields": {
                      "paymentTokens": {
                        "type": "string",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "Query": {
                    "fields": {
                      "queryString": {
                        "type": "string",
                        "id": 1
                      },
                      "instrumentSearch": {
                        "type": ".squareup.client.bills.GetBillFamiliesRequest.InstrumentSearch",
                        "id": 2
                      },
                      "billServerToken": {
                        "type": "string",
                        "id": 3
                      },
                      "paymentToken": {
                        "type": "string",
                        "id": 4
                      },
                      "paymentSearch": {
                        "type": ".squareup.client.bills.GetBillFamiliesRequest.PaymentSearch",
                        "id": 5
                      }
                    },
                    "nested": {
                      "filter": {
                        "oneof": ["queryString", "instrumentSearch", "billServerToken", "paymentToken", "paymentSearch"]
                      }
                    }
                  }
                }
              },
              "GetBillFamiliesResponse": {
                "fields": {
                  "status": {
                    "type": ".squareup.client.Status",
                    "id": 1,
                    "rule": "optional"
                  },
                  "billFamily": {
                    "type": ".squareup.client.bills.GetBillFamiliesResponse.BillFamily",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "paginationToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "contacts": {
                    "type": ".squareup.client.bills.GetBillFamiliesResponse.Contact",
                    "id": 4,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "BillFamily": {
                    "fields": {
                      "bill": {
                        "type": ".squareup.client.bills.Bill",
                        "id": 1,
                        "rule": "optional"
                      },
                      "relatedBill": {
                        "type": ".squareup.client.bills.Bill",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "relatedBillTokens": {
                        "type": "string",
                        "id": 3,
                        "rule": "repeated"
                      }
                    }
                  },
                  "Contact": {
                    "fields": {
                      "contactToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "displayName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "tenderTokens": {
                        "type": "string",
                        "id": 3,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              },
              "GetBillRefundableStatusRequest": {
                "fields": {
                  "billServerToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "billUnitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetBillRefundableStatusResponse": {
                "fields": {
                  "billIsRefundable": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "billIsNotRefundableReason": {
                    "type": ".squareup.client.bills.GetBillRefundableStatusResponse.BillNotRefundableReason",
                    "id": 2,
                    "rule": "optional"
                  },
                  "localizedNotRefundableReason": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "BillNotRefundableReason": {
                    "values": {
                      "UNKNOWN": 0,
                      "ALREADY_FULLY_REFUNDED": 1,
                      "PAST_REFUNDABLE_DATE": 2,
                      "TENDER_NOT_REFUNDABLE": 3,
                      "PAYMENT_DISPUTED": 4
                    }
                  }
                }
              },
              "GetResidualBillRequest": {
                "fields": {
                  "billServerToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "billUnitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetResidualBillResponse": {
                "fields": {
                  "canOnlyIssueAmountBasedRefund": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "residualItemization": {
                    "type": ".squareup.client.bills.GetResidualBillResponse.ResidualItemization",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "residualItemizationGroup": {
                    "type": ".squareup.client.bills.GetResidualBillResponse.ResidualItemizationGroup",
                    "id": 10,
                    "rule": "repeated"
                  },
                  "residualTender": {
                    "type": ".squareup.client.bills.GetResidualBillResponse.ResidualTender",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "residualTip": {
                    "type": ".squareup.client.bills.GetResidualBillResponse.ResidualTip",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "residualSurcharge": {
                    "type": ".squareup.client.bills.GetResidualBillResponse.ResidualSurcharge",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "amendmentToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "canNotIssueExchange": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional"
                  },
                  "soldFromUnitToken": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "refundConstraints": {
                    "type": ".squareup.client.bills.GetResidualBillResponse.BillRefundConstraint",
                    "id": 9,
                    "rule": "repeated"
                  },
                  "isBill": {
                    "type": "bool",
                    "id": 11,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "BillRefundConstraint": {
                    "values": {
                      "UNKNOWN": 0,
                      "CARD_MUST_BE_PRESENT": 1,
                      "FULL_REFUND_ONLY": 2
                    }
                  },
                  "ResidualItemization": {
                    "fields": {
                      "sourceBillServerToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "sourceItemizationTokenPair": {
                        "type": ".squareup.client.IdPair",
                        "id": 2,
                        "rule": "optional"
                      },
                      "sourceItemizationQuantity": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "itemization": {
                        "type": ".squareup.client.bills.Itemization",
                        "id": 3,
                        "rule": "optional"
                      },
                      "giftCard": {
                        "type": ".squareup.client.giftcards.GiftCard",
                        "id": 5,
                        "rule": "optional"
                      }
                    }
                  },
                  "ResidualItemizationGroup": {
                    "fields": {
                      "sourceBillTokenPair": {
                        "type": ".squareup.client.IdPair",
                        "id": 1,
                        "rule": "optional"
                      },
                      "sourceItemizationGroupTokenPair": {
                        "type": ".squareup.client.IdPair",
                        "id": 2,
                        "rule": "optional"
                      },
                      "itemizationGroup": {
                        "type": ".squareup.client.bills.ItemizationGroup",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "ResidualTender": {
                    "fields": {
                      "sourceBillServerToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "sourceTenderServerToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "tender": {
                        "type": ".squareup.client.bills.Tender",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "ResidualTip": {
                    "fields": {
                      "sourceBillServerToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "residualTip": {
                        "type": ".squareup.client.bills.TipLineItem",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "ResidualSurcharge": {
                    "fields": {
                      "sourceBillServerToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "residualSurcharge": {
                        "type": ".squareup.client.bills.SurchargeLineItem",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "GetRecentlyClosedBillsRequest": {
                "fields": {
                  "limit": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "filteredPaginationToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "unfilteredPaginationToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "employeeId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "ticketTemplateId": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "filterToAmendable": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "GetRecentlyClosedBillsResponse": {
                "fields": {
                  "status": {
                    "type": ".squareup.client.Status",
                    "id": 1,
                    "rule": "optional"
                  },
                  "filteredBill": {
                    "type": ".squareup.client.bills.Bill",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "filteredPaginationToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "unfilteredBill": {
                    "type": ".squareup.client.bills.Bill",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "unfilteredPaginationToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "GetSaleCartRequest": {
                "fields": {
                  "billServerToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetSaleCartResponse": {
                "fields": {
                  "status": {
                    "type": ".squareup.client.Status",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cart": {
                    "type": ".squareup.client.bills.Cart",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "BillListService": {
                "methods": {
                  "GetBills": {
                    "requestType": ".squareup.client.bills.GetBillsRequest",
                    "responseType": ".squareup.client.bills.GetBillsResponse"
                  },
                  "GetBillFamilies": {
                    "requestType": ".squareup.client.bills.GetBillFamiliesRequest",
                    "responseType": ".squareup.client.bills.GetBillFamiliesResponse"
                  },
                  "GetBillByTenderServerId": {
                    "requestType": ".squareup.client.bills.GetBillByTenderServerIdRequest",
                    "responseType": ".squareup.client.bills.GetBillByTenderServerIdResponse"
                  },
                  "GetBillByBillServerToken": {
                    "requestType": ".squareup.client.bills.GetBillByBillServerTokenRequest",
                    "responseType": ".squareup.client.bills.GetBillByBillServerTokenResponse"
                  },
                  "GetResidualBill": {
                    "requestType": ".squareup.client.bills.GetResidualBillRequest",
                    "responseType": ".squareup.client.bills.GetResidualBillResponse"
                  },
                  "GetRecentlyClosedBills": {
                    "requestType": ".squareup.client.bills.GetRecentlyClosedBillsRequest",
                    "responseType": ".squareup.client.bills.GetRecentlyClosedBillsResponse"
                  },
                  "GetSaleCart": {
                    "requestType": ".squareup.client.bills.GetSaleCartRequest",
                    "responseType": ".squareup.client.bills.GetSaleCartResponse"
                  },
                  "GetBillRefundableStatus": {
                    "requestType": ".squareup.client.bills.GetBillRefundableStatusRequest",
                    "responseType": ".squareup.client.bills.GetBillRefundableStatusResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetBillsRequest && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetBillsRequest?.nested?.QueryStringType && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetBillsRequest?.nested?.Query && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetBillsRequest?.nested?.InstrumentSearch && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetBillsRequest?.nested?.QueryParams && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetBillsResponse && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetBillByTenderServerIdRequest && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetBillByTenderServerIdResponse && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetBillByBillServerTokenRequest && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetBillByBillServerTokenResponse && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetBillFamiliesRequest && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetBillFamiliesRequest?.nested?.InstrumentSearch && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetBillFamiliesRequest?.nested?.PaymentSearch && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetBillFamiliesRequest?.nested?.Query && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetBillFamiliesResponse && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetBillFamiliesResponse?.nested?.BillFamily && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetBillFamiliesResponse?.nested?.Contact && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetBillRefundableStatusRequest && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetBillRefundableStatusResponse && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetBillRefundableStatusResponse?.nested?.BillNotRefundableReason && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetResidualBillRequest && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetResidualBillResponse && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetResidualBillResponse?.nested?.BillRefundConstraint && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetResidualBillResponse?.nested?.ResidualItemization && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetResidualBillResponse?.nested?.ResidualItemizationGroup && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetResidualBillResponse?.nested?.ResidualTender && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetResidualBillResponse?.nested?.ResidualTip && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetResidualBillResponse?.nested?.ResidualSurcharge && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetRecentlyClosedBillsRequest && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetRecentlyClosedBillsResponse && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetSaleCartRequest && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.GetSaleCartResponse && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.BillListService) {
  $root.addJSON(jsonData);
}

/**
 * This request only returns sale bills, which may include legacy refund tenders.
 * It will never return itemized refund bills.
 *
 * SOURCE GetBillsRequest @ squareup/client/bills/bill-list-service.proto at 29:1
 */
export const GetBillsRequest = $root.lookupType('squareup.client.bills.GetBillsRequest');
fixType(GetBillsRequest, {
  limit: {
    required: true
  }
});
Builder.createAndAttachToType(GetBillsRequest);
/**
 * SOURCE QueryStringType @ squareup/client/bills/bill-list-service.proto at 31:3
 */
GetBillsRequest.QueryStringType = $root.lookupEnum('squareup.client.bills.GetBillsRequest.QueryStringType').values;
/**
 * SOURCE Query @ squareup/client/bills/bill-list-service.proto at 57:3
 */
GetBillsRequest.Query = $root.lookupType('squareup.client.bills.GetBillsRequest.Query');
fixType(GetBillsRequest.Query, {
  queryStringType: {
    required: true
  },
  queryString: {
    required: true
  }
});
Builder.createAndAttachToType(GetBillsRequest.Query);
/**
 * SOURCE InstrumentSearch @ squareup/client/bills/bill-list-service.proto at 64:3
 */
GetBillsRequest.InstrumentSearch = $root.lookupType('squareup.client.bills.GetBillsRequest.InstrumentSearch');
fixType(GetBillsRequest.InstrumentSearch, {
  paymentInstrument: {
    required: true
  },
  entryMethod: {
    required: true
  }
});
Builder.createAndAttachToType(GetBillsRequest.InstrumentSearch);
/**
 * SOURCE QueryParams @ squareup/client/bills/bill-list-service.proto at 72:3
 */
GetBillsRequest.QueryParams = $root.lookupType('squareup.client.bills.GetBillsRequest.QueryParams');
fixType(GetBillsRequest.QueryParams);
Builder.createAndAttachToType(GetBillsRequest.QueryParams);
/**
 * SOURCE GetBillsResponse @ squareup/client/bills/bill-list-service.proto at 133:1
 */
export const GetBillsResponse = $root.lookupType('squareup.client.bills.GetBillsResponse');
fixType(GetBillsResponse, {
  status: {
    required: true
  }
});
Builder.createAndAttachToType(GetBillsResponse);
/**
 * SOURCE GetBillByTenderServerIdRequest @ squareup/client/bills/bill-list-service.proto at 143:1
 */
export const GetBillByTenderServerIdRequest = $root.lookupType('squareup.client.bills.GetBillByTenderServerIdRequest');
fixType(GetBillByTenderServerIdRequest, {
  tenderServerId: {
    required: true
  }
});
Builder.createAndAttachToType(GetBillByTenderServerIdRequest);
/**
 * SOURCE GetBillByTenderServerIdResponse @ squareup/client/bills/bill-list-service.proto at 152:1
 */
export const GetBillByTenderServerIdResponse = $root.lookupType('squareup.client.bills.GetBillByTenderServerIdResponse');
fixType(GetBillByTenderServerIdResponse, {
  status: {
    required: true
  }
});
Builder.createAndAttachToType(GetBillByTenderServerIdResponse);
/**
 * SOURCE GetBillByBillServerTokenRequest @ squareup/client/bills/bill-list-service.proto at 159:1
 */
export const GetBillByBillServerTokenRequest = $root.lookupType('squareup.client.bills.GetBillByBillServerTokenRequest');
fixType(GetBillByBillServerTokenRequest, {
  billServerToken: {
    required: true
  }
});
Builder.createAndAttachToType(GetBillByBillServerTokenRequest);
/**
 * SOURCE GetBillByBillServerTokenResponse @ squareup/client/bills/bill-list-service.proto at 165:1
 */
export const GetBillByBillServerTokenResponse = $root.lookupType('squareup.client.bills.GetBillByBillServerTokenResponse');
fixType(GetBillByBillServerTokenResponse, {
  status: {
    required: true
  }
});
Builder.createAndAttachToType(GetBillByBillServerTokenResponse);
/**
 * This newer endpoint is similar to GetBillsRequest, but differs in two ways:
 *
 * - This endpoint will also return itemized refund bills, not just original sale bills.
 *
 * - This endpoint will also return a BillFamily of related bills, alongside with each
 *   matching bill. (See response documentation for more precise details on BillFamily.)
 *
 * - Can exclude related bills to make this endpoint less expensive.
 *
 * If a query would match multiple bills in the same family (for example, because they
 * all involved a common payment instrument, or they all occurred in the period of time covered
 * by this page of results), the endpoint will return multiple bills, and each bill would get a
 * copy of their complete families. That is, families are NOT coalesced together in the response.
 *
 * SOURCE GetBillFamiliesRequest @ squareup/client/bills/bill-list-service.proto at 188:1
 */
export const GetBillFamiliesRequest = $root.lookupType('squareup.client.bills.GetBillFamiliesRequest');
fixType(GetBillFamiliesRequest, {
  limit: {
    required: true
  }
});
Builder.createAndAttachToType(GetBillFamiliesRequest);
/**
 * SOURCE InstrumentSearch @ squareup/client/bills/bill-list-service.proto at 193:3
 */
GetBillFamiliesRequest.InstrumentSearch = $root.lookupType('squareup.client.bills.GetBillFamiliesRequest.InstrumentSearch');
fixType(GetBillFamiliesRequest.InstrumentSearch, {
  paymentInstrument: {
    required: true
  },
  entryMethod: {
    required: true
  }
});
Builder.createAndAttachToType(GetBillFamiliesRequest.InstrumentSearch);
/**
 * SOURCE PaymentSearch @ squareup/client/bills/bill-list-service.proto at 201:3
 */
GetBillFamiliesRequest.PaymentSearch = $root.lookupType('squareup.client.bills.GetBillFamiliesRequest.PaymentSearch');
fixType(GetBillFamiliesRequest.PaymentSearch);
Builder.createAndAttachToType(GetBillFamiliesRequest.PaymentSearch);
/**
 * SOURCE Query @ squareup/client/bills/bill-list-service.proto at 206:3
 */
GetBillFamiliesRequest.Query = $root.lookupType('squareup.client.bills.GetBillFamiliesRequest.Query');
fixType(GetBillFamiliesRequest.Query);
Builder.createAndAttachToType(GetBillFamiliesRequest.Query);
/**
 * The response contains BillFamilies, each of which consists of a bill (which matched
 * the query), and a set of its related bills.
 *
 * For itemized refunds, a sale bill is related to its itemized refund bills, but you
 * should not assume this is the only possible relationship. In the future, exchanges
 * could cause bills to become related in complex ways that the service will mediate.
 *
 * Bills are currently members of their own families, though this may change as the
 * definition of a family evolves.
 *
 * The specific bill that matched the query is the bill field of the BillFamily, while
 * the related_bill field is ordered chronologically (oldest to newest). (Currently,
 * the matched bill will appear again in related_bills, so that its ordering with
 * respect to the rest of the family is specified.)
 *
 * Think of bill as what shows up in the tableview of activity, and related_bills
 * as the bills that show up in the detail view for that bill.
 *
 * (For the vast majority of responses, which are for singleton sale bills that don't
 * have an itemized refund or exchange, this means the result appears twice in the
 * response: once in the bill field, and once as a singleton related_bill inside
 * BillFamily.)
 *
 * Related bills are only populated if exclude_related_bills is false in the incoming
 * request.
 *
 * SOURCE GetBillFamiliesResponse @ squareup/client/bills/bill-list-service.proto at 305:1
 */
export const GetBillFamiliesResponse = $root.lookupType('squareup.client.bills.GetBillFamiliesResponse');
fixType(GetBillFamiliesResponse, {
  status: {
    required: true
  }
});
Builder.createAndAttachToType(GetBillFamiliesResponse);
/**
 * SOURCE BillFamily @ squareup/client/bills/bill-list-service.proto at 309:3
 */
GetBillFamiliesResponse.BillFamily = $root.lookupType('squareup.client.bills.GetBillFamiliesResponse.BillFamily');
fixType(GetBillFamiliesResponse.BillFamily);
Builder.createAndAttachToType(GetBillFamiliesResponse.BillFamily);
/**
 * SOURCE Contact @ squareup/client/bills/bill-list-service.proto at 318:3
 */
GetBillFamiliesResponse.Contact = $root.lookupType('squareup.client.bills.GetBillFamiliesResponse.Contact');
fixType(GetBillFamiliesResponse.Contact, {
  contactToken: {
    required: true
  },
  displayName: {
    required: true
  },
  tenderTokens: {
    required: true
  }
});
Builder.createAndAttachToType(GetBillFamiliesResponse.Contact);
/**
 * This request checks if the bill provided is refundable or not at the time
 * of the request.
 *
 * This endpoint will return a boolean YES or NO.
 * If NO, it will include a reason.
 * A human readable string is optional.
 *
 * SOURCE GetBillRefundableStatusRequest @ squareup/client/bills/bill-list-service.proto at 358:1
 */
export const GetBillRefundableStatusRequest = $root.lookupType('squareup.client.bills.GetBillRefundableStatusRequest');
fixType(GetBillRefundableStatusRequest, {
  billServerToken: {
    required: true
  }
});
Builder.createAndAttachToType(GetBillRefundableStatusRequest);
/**
 * The response contains the refundable status of a bill.
 *
 * This response will return a YES or NO boolean that indicates if the bill is
 * refundable at the moment of the request.
 *
 * If a bill is not refundable (indicated with a NO above) it will also return
 * a string reason of why it is not refundable.
 *
 * If the server wants to display a message directly it should send it in
 * localized_not_refundable_reason.
 *
 * SOURCE GetBillRefundableStatusResponse @ squareup/client/bills/bill-list-service.proto at 385:1
 */
export const GetBillRefundableStatusResponse = $root.lookupType('squareup.client.bills.GetBillRefundableStatusResponse');
fixType(GetBillRefundableStatusResponse);
Builder.createAndAttachToType(GetBillRefundableStatusResponse);
/**
 * SOURCE BillNotRefundableReason @ squareup/client/bills/bill-list-service.proto at 387:3
 */
GetBillRefundableStatusResponse.BillNotRefundableReason = $root.lookupEnum('squareup.client.bills.GetBillRefundableStatusResponse.BillNotRefundableReason').values;
/**
 * This requests some aggregated data from a bill family, specifically the
 * "residual" itemizations and tenders that are still eligible for return and
 * refund, respectively.
 *
 * The bill id passed up can refer to ANY bill in a bill family, not just the
 * original sale bill. The residual bill that is generated should be the same
 * regardless of which bill family member is the basis for the request.
 *
 * SOURCE GetResidualBillRequest @ squareup/client/bills/bill-list-service.proto at 433:1
 */
export const GetResidualBillRequest = $root.lookupType('squareup.client.bills.GetResidualBillRequest');
fixType(GetResidualBillRequest, {
  billServerToken: {
    required: true
  }
});
Builder.createAndAttachToType(GetResidualBillRequest);
/**
 * This response returns residual_itemizations and residual_tenders to guide
 * client itemized refund UI in selecting itemizations for return and and assigning
 * amounts to refund to tenders.
 *
 * The residual messages also include the tokens needed to link back up to
 * source bills, source itemizations, and source tenders when submitting
 * back to the IssueRefunds endpoint on the BillRefundService.
 *
 * SOURCE GetResidualBillResponse @ squareup/client/bills/bill-list-service.proto at 457:1
 */
export const GetResidualBillResponse = $root.lookupType('squareup.client.bills.GetResidualBillResponse');
fixType(GetResidualBillResponse);
Builder.createAndAttachToType(GetResidualBillResponse);
/**
 * SOURCE BillRefundConstraint @ squareup/client/bills/bill-list-service.proto at 459:3
 */
GetResidualBillResponse.BillRefundConstraint = $root.lookupEnum('squareup.client.bills.GetResidualBillResponse.BillRefundConstraint').values;
/**
 * Information on itemizations (including quantity, fees, and discounts) which are
 * still eligible for return.
 *
 * SOURCE ResidualItemization @ squareup/client/bills/bill-list-service.proto at 492:3
 */
GetResidualBillResponse.ResidualItemization = $root.lookupType('squareup.client.bills.GetResidualBillResponse.ResidualItemization');
fixType(GetResidualBillResponse.ResidualItemization);
Builder.createAndAttachToType(GetResidualBillResponse.ResidualItemization);
/**
 * SOURCE ResidualItemizationGroup @ squareup/client/bills/bill-list-service.proto at 537:3
 */
GetResidualBillResponse.ResidualItemizationGroup = $root.lookupType('squareup.client.bills.GetResidualBillResponse.ResidualItemizationGroup');
fixType(GetResidualBillResponse.ResidualItemizationGroup);
Builder.createAndAttachToType(GetResidualBillResponse.ResidualItemizationGroup);
/**
 * Information on tenders (including amounts) which are still eligible for refund.
 *
 * SOURCE ResidualTender @ squareup/client/bills/bill-list-service.proto at 549:3
 */
GetResidualBillResponse.ResidualTender = $root.lookupType('squareup.client.bills.GetResidualBillResponse.ResidualTender');
fixType(GetResidualBillResponse.ResidualTender);
Builder.createAndAttachToType(GetResidualBillResponse.ResidualTender);
/**
 * Information on the tip line items (including source tender, applied amount)
 * which are still eligible for refund.
 *
 * SOURCE ResidualTip @ squareup/client/bills/bill-list-service.proto at 575:3
 */
GetResidualBillResponse.ResidualTip = $root.lookupType('squareup.client.bills.GetResidualBillResponse.ResidualTip');
fixType(GetResidualBillResponse.ResidualTip);
Builder.createAndAttachToType(GetResidualBillResponse.ResidualTip);
/**
 * Information on the surcharge line items (including source tender, applied amount)
 * which are still eligible for refund.
 *
 * SOURCE ResidualSurcharge @ squareup/client/bills/bill-list-service.proto at 591:3
 */
GetResidualBillResponse.ResidualSurcharge = $root.lookupType('squareup.client.bills.GetResidualBillResponse.ResidualSurcharge');
fixType(GetResidualBillResponse.ResidualSurcharge);
Builder.createAndAttachToType(GetResidualBillResponse.ResidualSurcharge);
/**
 * SOURCE GetRecentlyClosedBillsRequest @ squareup/client/bills/bill-list-service.proto at 649:1
 */
export const GetRecentlyClosedBillsRequest = $root.lookupType('squareup.client.bills.GetRecentlyClosedBillsRequest');
fixType(GetRecentlyClosedBillsRequest, {
  limit: {
    required: true
  }
});
Builder.createAndAttachToType(GetRecentlyClosedBillsRequest);
/**
 * SOURCE GetRecentlyClosedBillsResponse @ squareup/client/bills/bill-list-service.proto at 694:1
 */
export const GetRecentlyClosedBillsResponse = $root.lookupType('squareup.client.bills.GetRecentlyClosedBillsResponse');
fixType(GetRecentlyClosedBillsResponse, {
  status: {
    required: true
  }
});
Builder.createAndAttachToType(GetRecentlyClosedBillsResponse);
/**
 * SOURCE GetSaleCartRequest @ squareup/client/bills/bill-list-service.proto at 726:1
 */
export const GetSaleCartRequest = $root.lookupType('squareup.client.bills.GetSaleCartRequest');
fixType(GetSaleCartRequest, {
  billServerToken: {
    required: true
  }
});
Builder.createAndAttachToType(GetSaleCartRequest);
/**
 * SOURCE GetSaleCartResponse @ squareup/client/bills/bill-list-service.proto at 730:1
 */
export const GetSaleCartResponse = $root.lookupType('squareup.client.bills.GetSaleCartResponse');
fixType(GetSaleCartResponse, {
  status: {
    required: true
  }
});
Builder.createAndAttachToType(GetSaleCartResponse);
/**
 * SOURCE BillListService @ squareup/client/bills/bill-list-service.proto at 740:1
 */
export const BillListService = $root.lookupService('squareup.client.bills.BillListService');